import { render } from "./PostList.vue?vue&type=template&id=a1a3e780&ts=true"
import script from "./PostList.vue?vue&type=script&lang=ts"
export * from "./PostList.vue?vue&type=script&lang=ts"

import "./PostList.vue?vue&type=style&index=0&id=a1a3e780&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__